import React, { useRef } from 'react';
import { Form, Col } from 'reactstrap';
import { apiErrorHandler } from '../../actions/generic_items';

import ImageUpload from '../../components/ImageUpload/ImageUpload';
import FloatingModal from '../../components/Modal/FloatingModal';

const AvatarModal = ({
  avatar,
  toggleModal,
  translate,
  startReloadData,
  startSetAvatar,
  isModalOpen
}) => {
  const uploadRef = useRef();

  const handleCancel = () => {
    toggleModal();
  };

  const onSubmit = () => {
    const onSaveAvatar = uploadRef?.current?.onSaveAvatar;

    if (!onSaveAvatar) {
      toggleModal();
      return;
    }

    onSaveAvatar()
      .then(() => {
        startReloadData();
        toggleModal();
      })
      .catch(error => {
        apiErrorHandler(error);
      });
  };

  return (
    <FloatingModal
      isOpen={isModalOpen}
      toggleModal={toggleModal}
      header={translate('avatar_edit')}
      translate={translate}
      onCancel={handleCancel}
      onConfirm={onSubmit}
      size="small"
    >
      <section>
        <Form>
          <Col xs="6">
            <ImageUpload
              src={avatar}
              ref={uploadRef}
              startSetAvatar={startSetAvatar}
            />
          </Col>
        </Form>
      </section>
    </FloatingModal>
  );
};

export default AvatarModal;
